import { axiosInstance } from '../Config/axios';

const API_URL = `v1/licences/`;

export const getLicences = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las licences:', error);
    throw error;
  }
};